import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import { Link, ResponsiveImage } from "@quintype/components";
import { getSlug } from "../../../utils";

import "./common-collection-card.m.css";

const CommonCollectionCard = ({ collection, config }) => {
  const slug = getSlug(collection, config);
  const collectionName = get(collection, ["name"], "");
  const collectionSummary = get(collection, ["summary"], "");
  const defaultImgS3Key = get(config, ["publisher", "publisher", "defaulImgS3key"], "");
  const imgS3Key = get(collection, ["metadata", "cover-image", "cover-image-s3-key"], defaultImgS3Key);
  const imgMetadata = get(collection, ["metadata", "cover-image", "cover-image-metadata"], {});
  return (
    <div styleName="card-container">
      <Link href={slug} styleName="hero-image" className="hero-image">
        <figure className="image">
          <ResponsiveImage
            slug={imgS3Key}
            metadata={imgMetadata}
            aspectRatio={[370, 208]}
            defaultWidth={259}
            widths={[250, 480]}
            className="responsive-img"
          />
        </figure>
      </Link>
      <div styleName="text-container">
        <Link href={slug}>
          <h2 styleName="headline">
            <bdi dangerouslySetInnerHTML={{ __html: collectionName }} />
          </h2>
        </Link>
        <h1 styleName="subheadline">
          <bdi dangerouslySetInnerHTML={{ __html: collectionSummary }} />
        </h1>
      </div>
    </div>
  );
};

CommonCollectionCard.propTypes = {
  collection: PropTypes.object,
  config: PropTypes.object
};

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"], {})
});

export default connect(mapStateToProps)(CommonCollectionCard);
